import React, { useState, useEffect } from "react";
import Axios from "axios";
import MACSearch from "../CustomComponents/MACSearch/MACSearch";
import { GetCookie } from "../../exports/CookieManagement";
import { GetRoleType } from "../../exports/RoleTypes";
import { Navigate, NavLink, Route, Routes, useLocation } from "react-router-dom";
import Pulse from "../Loader/Pulse";
import Portfolio from "../MFManagement/Portfolio";
import Sip from "../MFManagement/Sip";
import Account from "../MFManagement/Account";
import Transaction from "../MFManagement/Transaction";
import { OrderBook } from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";
import SipTransaction from "../MFManagement/SipTransaction";


const REQUEST_BASE_URL = process.env.REACT_APP_REQUEST_BASE_URL;

function PortfolioHeader({ user_role_type, customers, activeCustomer, setCustomer }) {
  return (
    <div className={`portfolio__options ${user_role_type === "BROKER" ? "full" : ""}`}>
      {user_role_type === "BROKER" && (
        <div className="portfolio__selection">
          <div className="portfolio__customer">
            <MACSearch
              title="Search Client"
              customers={customers}
              onSelect={(val) => {
                setCustomer(val);
                localStorage.setItem("selectedCustomerToken", val.customer_token);
              }}
              selectedCustomer={activeCustomer}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function PortfolioMenu({ user_role_type, activeCustomer }) {
  const location = useLocation();
  const { pathname = "" } = location;

  let customer_token = false;
  if (activeCustomer && activeCustomer.customer_token) {
    customer_token = activeCustomer.customer_token;
  }

  return (
    <>
      {user_role_type === "BROKER" && (
        <>
          <NavLink
            to={
              customer_token
                ? `/account/fundportfolio/mfportfolio?customer=${customer_token}`
                : "/account/fundportfolio/mfportfolio"
            }
          >
            <p
              className={pathname === "/account/fundportfolio/mfportfolio" ? "active" : ""}
            >
              Portfolio
            </p>
          </NavLink>
        </>
      )}

      <NavLink
        to={
          customer_token
            ? `/account/fundportfolio/mfsip?customer=${customer_token}`
            : "/account/fundportfolio/mfsip"
        }
      >
        <p
          className={pathname === "/account/fundportfolio/mfsip" ? "active" : ""}
        >
          SIP
        </p>
      </NavLink>

      <NavLink
        to={
          customer_token
            ? `/account/fundportfolio/mftransactions?customer=${customer_token}`
            : "/account/fundportfolio/mftransactions"
        }
      >
        <p
          className={pathname === "/account/fundportfolio/mftransactions" ? "active" : ""}
        >
          Transactions
        </p>
      </NavLink>

      <NavLink
        to={
          customer_token
            ? `/account/fundportfolio/mfsiptransactions?customer=${customer_token}`
            : "/account/fundportfolio/mfsiptransactions"
        }
      >
        <p
          className={pathname === "/account/fundportfolio/mfsiptransactions" ? "active" : ""}
        >
          SIP Transactions
        </p>
      </NavLink>

      <NavLink
        to={
          customer_token
            ? `/account/fundportfolio/mfaccount?customer=${customer_token}`
            : "/account/fundportfolio/mfaccount"
        }
      >
        <p
          className={pathname === "/account/fundportfolio/mfaccount" ? "active" : ""}
        >
          Account
        </p>
      </NavLink>
    </>
  );
}

const FundPortfolioManagement = () => {
  const [customers, setCustomers] = useState([]);
  const [isCustomerLoaded, setIsCustomerLoaded] = useState(false);
  const [activeCustomer, setActiveCustomer] = useState(null);

  const location = useLocation();
  const currentPath = location.pathname;

  const account_token = GetCookie("token");
  const user_role_type = GetRoleType(GetCookie("role"));

  console.log(activeCustomer)

  //   useEffect

  useEffect(() => {
    setIsCustomerLoaded(true)
    if (account_token) getMACustomers(account_token);
    setIsCustomerLoaded(false)
  }, [account_token]);


  const getMACustomers = (token) => {
    Axios.get(`${REQUEST_BASE_URL}/fundportfolio/customers?token=${token}`)
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          const fetchedCustomers = data.customers || [];
          setCustomers(fetchedCustomers);
          setIsCustomerLoaded(true);

          // 🔹 Priority 1: Query param
          const queryParams = new URLSearchParams(location.search);
          const encodedCustomerToken = queryParams.get("customer");

          // 🔹 Priority 2: Stored token
          const storedToken = localStorage.getItem("selectedCustomerToken");

          const finalToken = encodedCustomerToken || storedToken;

          if (finalToken) {
            const selectedCustomer = fetchedCustomers.find(
              (c) => c.customer_token === finalToken
            );
            if (selectedCustomer) {
              setActiveCustomer(selectedCustomer);
            }
          }
        } else {
          setIsCustomerLoaded(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsCustomerLoaded(true);
        setCustomers([]);
      });
  };



  return (
    <div className="swift-mf-portfolio-management swift-content">
      {!isCustomerLoaded ? (
        <>
          <div className="portfolio__container loader">
            <Pulse />
            <p>Loading Portfolio Management...</p>
          </div>
        </>
      ) : (
        <>
          {customers.length === 0 ? (
            <>
              <div className="order-container-empty">
                <OrderBook size={40} color={COLOR_VARS["SWIFT_COLOR4"]} />
                <div>
                  <p>No customers found</p>
                  <span>Looks like you have't made any active customers</span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="swift-submenu">
                <PortfolioMenu
                  user_role_type={user_role_type}
                  activeCustomer={activeCustomer}
                />
              </div>
              <div className="strategy-content">
                <Routes>
                  <Route
                    path="mfportfolio"
                    element={
                      <>
                        <PortfolioHeader
                          currentPath={currentPath}
                          user_role_type={user_role_type}
                          customers={customers}
                          activeCustomer={activeCustomer}
                          setCustomer={setActiveCustomer}
                        />
                        {activeCustomer ? (
                          // <div class="swift_mf_fund_portfolio_container">
                          <Portfolio
                            key={activeCustomer?.customer_token}
                            customer={activeCustomer}
                            hide={currentPath !== "/account/fundportfolio/mfportfolio"}
                          />
                          // </div>
                        ) : (
                          <div className="order-container-empty">
                            <OrderBook size={40} color={COLOR_VARS["SWIFT_COLOR4"]} />
                            <div>
                              <p>No customer selected</p>
                              <span>Looks like you have't select any customer</span>
                            </div>
                          </div>
                        )}
                      </>
                    }
                  />

                  <Route
                    path="mfsip"
                    element={
                      <>
                        <PortfolioHeader
                          currentPath={currentPath}
                          user_role_type={user_role_type}
                          customers={customers}
                          activeCustomer={activeCustomer}
                          setCustomer={setActiveCustomer}
                        />
                        {activeCustomer ? (
                          <Sip
                            key={activeCustomer?.customer_token}
                            customer={activeCustomer}
                            hide={currentPath === "/account/portfolio/mfsip" ? false : true}
                          />
                        ) : (
                          <div className="portfolio__container empty">
                            <p>Please select a customer to view the portfolio.</p>
                          </div>
                        )}

                      </>
                    }
                  />
                  <Route
                    path="mftransactions"
                    element={
                      <>
                        <PortfolioHeader
                          currentPath={currentPath}
                          user_role_type={user_role_type}
                          customers={customers}
                          activeCustomer={activeCustomer}
                          setCustomer={setActiveCustomer}
                        />
                        {activeCustomer ? (
                          <Transaction
                            key={activeCustomer?.customer_token}
                            customer={activeCustomer}
                            hide={currentPath === "/account/portfolio/mftransactions" ? false : true}
                          />
                        ) : (
                          <div className="portfolio__container empty">
                            <p>Please select a customer to view the portfolio.</p>
                          </div>
                        )}

                      </>
                    }
                  />
                  <Route
                    path="mfsiptransactions"
                    element={
                      <>
                        <PortfolioHeader
                          currentPath={currentPath}
                          user_role_type={user_role_type}
                          customers={customers}
                          activeCustomer={activeCustomer}
                          setCustomer={setActiveCustomer}
                        />
                        {activeCustomer ? (
                          <SipTransaction
                            key={activeCustomer?.customer_token}
                            customer={activeCustomer}
                            hide={currentPath === "/account/portfolio/mfsiptransactions" ? false : true}
                          />
                        ) : (
                          <div className="portfolio__container empty">
                            <p>Please select a customer to view the portfolio.</p>
                          </div>
                        )}

                      </>
                    }
                  />
                  <Route
                    path="mfaccount"
                    element={
                      <>
                        <PortfolioHeader
                          currentPath={currentPath}
                          user_role_type={user_role_type}
                          customers={customers}
                          activeCustomer={activeCustomer}
                          setCustomer={setActiveCustomer}
                        />
                        {activeCustomer ? (
                          <Account
                            key={activeCustomer?.customer_token}
                            customer={activeCustomer}
                            hide={currentPath === "/account/portfolio/mfaccount" ? false : true}
                          />
                        ) : (
                          <div className="portfolio__container empty">
                            <p>Please select a customer to view the portfolio.</p>
                          </div>
                        )}

                      </>
                    }
                  />

                  <Route
                    path="*"
                    element={
                      <Navigate to="/account/fundportfolio/mfportfolio" />
                    }
                  />
                </Routes>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default FundPortfolioManagement;
